import { Box, Checkbox, FormControlLabel, Typography } from "@material-ui/core";
import uploadPhoto from "../../Image/upload 1.png";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import "./Modal.css";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  input: {
    display: "none",
  },
}));

function Modal({ setModalOpen, setAfterSubmitModalOpen }) {
  const classes = useStyles();
  return (
    <div className="modalBackground ">
      <div className="modalContainer">
        <div className="titleCloseBtn">
          <button
            onClick={() => {
              setModalOpen(false);
            }}
          >
            X
          </button>
        </div>
        <div className="title">
          <h1> Registration Form</h1>
        </div>
        <div className="subtitle">
          <p>
            Fill out this quick form and get started with your Tristar Logistics
            Marketplace ( All fields are mandatory)
          </p>
        </div>
        <div className="body">
          <div>
            <div className="modalInput">
              <div className="modal_label_input">
                <label htmlFor="">Company Trade License Number </label>
                <input type="text" />
              </div>
              <div className="modal_label_input">
                <label htmlFor="">Company Name * </label>
                <input type="text" />
              </div>
            </div>
            <div className="modalInput">
              <div className="modal_label_input">
                <label htmlFor="">Authorized Mobile Number </label>
                <input type="text" />
              </div>
              <div className="modal_label_input">
                <label htmlFor="">Authorized Email ID*</label>
                <input type="text" />
              </div>
            </div>
            <div className="modalInput">
              <div className="modal_label_input">
                <label htmlFor="">Country</label>
                <input type="text" />
              </div>
              <div className="modal_label_input">
                <label htmlFor="">Enter Rematks (if any)</label>
                <input type="text" />
              </div>
            </div>
            <div className="upload_document_main">
              <h5>KYC(Upload Documents)</h5>
              <div className="RegistrationContent">
                <Box className="upload_document">
                  <div className="">
                    <input
                      accept="image/*"
                      className={classes.input}
                      id="icon-button-photo"
                      type="file"
                    />
                    <label htmlFor="icon-button-photo">
                      <img src={uploadPhoto} alt="uploadPhoto" />
                    </label>
                    <Typography variant="h5">Trade License</Typography>
                  </div>
                </Box>
                <Box className="upload_document">
                  <div className="">
                    <input
                      accept="image/*"
                      className={classes.input}
                      id="icon-button-photo"
                      type="file"
                    />
                    <label htmlFor="icon-button-photo">
                      <img src={uploadPhoto} alt="uploadPhoto" />
                    </label>
                    <Typography variant="h5">VAT Certificate</Typography>
                  </div>
                </Box>
                <Box className="upload_document">
                  <div className="">
                    <input
                      accept="image/*"
                      className={classes.input}
                      id="icon-button-photo"
                      type="file"
                    />
                    <label htmlFor="icon-button-photo">
                      <img src={uploadPhoto} alt="uploadPhoto" />
                    </label>
                    <Typography variant="h5">Passport Copy</Typography>
                  </div>
                </Box>
              </div>
            </div>
            <div className="buttonBodys">
              <Typography variant="h5" className="buttonBodySub">
                I agree to the following:
              </Typography>
              <Typography variant="h5">
                Agree to the Tristar Business User Terms and Conditions.
              </Typography>
              <FormControlLabel
                control={
                  <Checkbox
                    // onChange={handleChange}
                    name="checkedB"
                    color="primary"
                  />
                }
                label="I agree to all the above"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    // onChange={handleChange}
                    name="checkedB"
                    color="primary"
                  />
                }
                label="By submission of this form, I hereby confirm that  I am authorized to sign this application form on behalf of the named company above."
              />
            </div>
          </div>
        </div>

        <div className="footer">
          <Link to={"/"} onClick={() => setModalOpen(false)}>
            <button
              onClick={() => {
                setAfterSubmitModalOpen(true);
              }}
            >
              Submit
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Modal;
